import { dishCodeBadge } from '@/features/menu/dishCode';
import { catalogName } from '@/lib/localizeCatalog';
import type { CartLine, CartLineSnapshot, Menu } from '@/types';

/** "[T8] Name" for cart/confirmation text lines; plain name when the code is
 * absent or already part of the name. */
export function withCartCode(snapshot: CartLineSnapshot): string {
  const name = catalogName(snapshot);
  const badge = dishCodeBadge(name, snapshot.code);
  return badge ? `[${badge}] ${name}` : name;
}

/** SC-1278 — les lignes venues du serveur (confirmation, historique) portent le
 *  nom français sans traductions : on les prend, si le menu est déjà chargé, sur
 *  le plat du même uuid. Sans menu, le nom du serveur reste tel quel. */
export function localizableSnapshot(line: CartLine, menu: Menu | undefined): CartLineSnapshot {
  const translations = menu?.items.find((i) => i.id === line.itemId)?.translations;
  return translations ? { ...line.snapshot, translations } : line.snapshot;
}
